import { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Linkedin, Mail, Award } from "lucide-react";

export default function TeamPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const team = [
    {
      id: 1,
      name: "Alexander Grant",
      role: "Founder & CEO",
      bio: "25+ years in algorithmic trading and fintech. Previously led trading operations at major hedge funds.",
      expertise: "Trading Strategy, AI/ML, Blockchain",
      email: "alexandergrant690@gmail.com"
    },
    {
      id: 2,
      name: "Maria Gonzalez",
      role: "Chief Technology Officer",
      bio: "Former Google engineer specializing in distributed systems and machine learning infrastructure.",
      expertise: "Cloud Architecture, AI/ML, Security",
      email: "mariagonzalezmaria69@gmail.com"
    },
    {
      id: 3,
      name: "James Whitmore",
      role: "Head of Compliance",
      bio: "Compliance officer with 20+ years experience in financial services and cryptocurrency regulation.",
      expertise: "Regulatory Compliance, AML/KYC, Risk Management",
      email: "whitmorejames782@gmail.com"
    },
    {
      id: 4,
      name: "Dr. Sarah Chen",
      role: "Lead AI Researcher",
      bio: "PhD in Machine Learning. Former researcher at OpenAI, specializes in algorithmic trading models.",
      expertise: "Machine Learning, Data Science, Trading Models",
      email: "drsarahchen4@gmail.com"
    },
    {
      id: 5,
      name: "Michael Rodriguez",
      role: "Head of Operations",
      bio: "Operations expert with background in financial technology and customer experience optimization.",
      expertise: "Operations, Customer Success, Process Optimization",
      email: "michaelrodriguezduo@gmail.com"
    },
    {
      id: 6,
      name: "Emma Larsson",
      role: "Security & Infrastructure",
      bio: "Cybersecurity specialist with expertise in blockchain security and financial infrastructure.",
      expertise: "Cybersecurity, Blockchain, Infrastructure",
      email: "emma@duocapital.com"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <section className="flex-1 max-w-6xl mx-auto px-6 py-16 w-full">
        <div className="mb-12">
          <h1 className="font-display text-4xl lg:text-5xl font-black mb-4">
            Meet Our <span className="gold-grad">Team</span>
          </h1>
          <p className="text-white/60 text-lg max-w-2xl">
            Experienced professionals dedicated to bringing transparent, secure, and profitable investment opportunities to everyone globally.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {team.map(member => (
            <div key={member.id} className="glass-strong rounded-2xl p-6 hover:border-[#D4AF37] border border-white/10 transition-all duration-300 group">
              <div className="flex items-start justify-between mb-4">
                <div>
                  <h3 className="font-display text-xl font-bold">{member.name}</h3>
                  <p className="text-sm text-[#D4AF37] font-semibold">{member.role}</p>
                </div>
                <Award className="w-5 h-5 text-[#D4AF37] opacity-0 group-hover:opacity-100 transition-opacity" />
              </div>

              <p className="text-sm text-white/70 mb-4">{member.bio}</p>

              <div className="mb-4">
                <p className="text-xs text-white/50 uppercase tracking-widest mb-2">Expertise</p>
                <div className="flex flex-wrap gap-2">
                  {member.expertise.split(", ").map((skill, i) => (
                    <span key={i} className="px-2 py-1 rounded text-xs bg-[#D4AF37]/20 text-[#D4AF37]">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>

              <div className="border-t border-white/10 pt-4">
                <a href={`mailto:${member.email}`} className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#D4AF37] transition-colors">
                  <Mail className="w-4 h-4" />
                  {member.email}
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Company Values */}
        <div className="mt-16 grid md:grid-cols-3 gap-6">
          <div className="glass-strong rounded-2xl p-8 text-center">
            <div className="text-4xl mb-4">🎯</div>
            <h3 className="font-display text-xl font-bold mb-2">Transparency</h3>
            <p className="text-white/60 text-sm">All operations and financial data are independently audited and disclosed to our users.</p>
          </div>

          <div className="glass-strong rounded-2xl p-8 text-center">
            <div className="text-4xl mb-4">🔒</div>
            <h3 className="font-display text-xl font-bold mb-2">Security</h3>
            <p className="text-white/60 text-sm">Bank-grade encryption and multi-layer security protect every transaction and user asset.</p>
          </div>

          <div className="glass-strong rounded-2xl p-8 text-center">
            <div className="text-4xl mb-4">💡</div>
            <h3 className="font-display text-xl font-bold mb-2">Innovation</h3>
            <p className="text-white/60 text-sm">Cutting-edge AI and machine learning drive superior trading strategies and returns.</p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
